import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AccessibilityBypassBlock } from "@skillz/accessibility";
import ScrollLTR from "../../../shared/components/ui/scrollLTR/ScrollLTR";
import { isMenuRoute } from "../../constants/menuTabs";
import pathRouts from "../../../shared/enums/pathRoute";
import MenuMobile from "./menuMobile/MenuMobile";
import LandscapeMessage from "./landscapeMessage/LandscapeMessage";
import classes from "./LayoutMobile.module.css";

const LayoutMobile = ({ dynamicTabs }) => {

    const { texts } = useSelector(state => state.translate);
    const scrollerRef = useRef(null);
    const location = useLocation();
    const showMenu = isMenuRoute(location.pathname, dynamicTabs);
    const isIframeRoute = dynamicTabs?.some(tab => tab.type === "iframe" && location.pathname.includes(tab.route)) || location.pathname.includes(pathRouts.BOT);

    useEffect(() => {
        if (!location.hash && scrollerRef.current) {
            scrollerRef.current.scrollTop = 0;
            scrollerRef.current.scrollLeft = 0;
        }
    }, [location.pathname, location.hash]);

    return (
        <div className={classes.Layout}>
            <AccessibilityBypassBlock id="main" text={texts.skipToMainContent} />
            <LandscapeMessage />
            <div className={classes.MobileShell}>
                <main className={`${classes.Main} ${showMenu ? classes.WithMenu : classes.NoMenu}`}>
                    <ScrollLTR ref={scrollerRef} dropClass={`${classes.Outlet} ${isIframeRoute ? classes.OutletIframe : ''}`} height="100%">
                        <div className={isIframeRoute ? classes.ContentIframe : classes.Content}>
                            <Outlet />
                        </div>
                    </ScrollLTR>
                </main>
                {showMenu && <MenuMobile dynamicTabs={dynamicTabs} />}
            </div>
        </div>
    );
};

export default LayoutMobile;
